import Crud from '../components/ClassXRecipe/Crud'
import Edit from '../components/ClassXRecipe/Edit'

let routes = {
    path: '/questionClass',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/questionClass',
            component: Crud
        },
        {
            path: '/questionClass/edit/:id',
            component: Edit
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/questionClassRecipe.js